
import React from 'react'
import Paper from 'material-ui/Paper';
import MoveLock from '../../../../components/movelock/MoveLock';
import MoveBackLockTohome from '../../../../components/movelock/moveBackLockToHome'

import { lock as ROLES_CONFIG } from '../../../../config/roles';

export default class Lock extends React.Component {

  constructor(props) {
    super(props);
    //console.log(ROLES_CONFIG,this.props.authenticated.role);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.movelock.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <MoveLock />
              </Paper> 
            : null 
          }
          {
            ROLES_CONFIG.movelockbackToHome.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-6 col-12 ml-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <MoveBackLockTohome />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/move-locks/MoveLock.js